exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feedbackMessage {\n    position: fixed;\n    box-shadow: 0px 3px 8px #888888;\n    min-width: 100px;\n    top: 50px;\n    z-index: 10000;\n    right: 0;\n    padding: 16px;\n    border-radius: 8px 0px 0px 8px;\n    color: #fff;\n    transform: translateX(calc(100% + 20px));\n    transition-property: transform;\n    transition-duration: 100ms;\n}\n\n.feedbackMessage--open {\n    transform: translateX(0%);\n}\n", ""]);

// exports
